export default __webpack_public_path__ + "static/media/swap.2eefa107.svg";